/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit, Optional, Inject } from "@angular/core";
import { Validators, FormBuilder } from "@angular/forms";
import { FilesInterface } from "src/app/models/files/files.interface";
import { icons } from "src/environments/config";
import { setActualDimensions } from "src/app/features/liveshop/utils/helpers";
import { SignInService } from "src/app/features/auth-feature/authServices/signin.service";
import { BusinessUsersApiService } from "src/app/services/my-company/business-users/business-users-api.service";
import { ImagesService } from "src/app/services/images/images.service";
import { RegexService } from "src/app/services/shared/regex/regex.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { PhoneNumberFormat, SearchCountryField } from "ngx-intl-tel-input";
import { SlotService } from "src/app/services/slot/slot.service";
import { DialogService } from "src/app/services/dialog-service/dialog.service";
import { SideNavComponent } from "src/app/features/user/side-nav/side-nav.component";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit {
  public profileForm = this.formBuilder.group({
    displayName: ["", Validators.required],
    firstName: ["", Validators.required],
    lastName: ["", Validators.required],
    mobile: [""],
    phoneNumber: [""],
    email: [""],
    profileImageURL: [""],
    companyName: [""],
    countryCode: [""],
    dialCode: [""],
  });
  phoneNumber;
  SearchCountryField = SearchCountryField;
  PhoneNumberFormat = PhoneNumberFormat;
  isFormData = false;
  user;
  phoneRegex = /^[1-9][0-9]*$/;
  windowHeight: number;
  windowWidth: number;
  public uploadFiles: FilesInterface = {};
  public businessUserIcon = icons.businessUserIcon.defaultImg;
  displayingImage;

  constructor(
    public signinService: SignInService,
    public formBuilder: FormBuilder,
    public businessUsersApiService: BusinessUsersApiService,
    public imagesService: ImagesService,
    public regexService: RegexService,
    @Optional() public dialogRef: MatDialogRef<ProfileComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public toastrService: ToastrService,
    public slotService: SlotService,
    public dialogService: DialogService,
    public localStorageService: LocalStorageService
  ) {}
  userData;
  ngOnInit(): void {
    this.signinService.getCurrentUserData().subscribe((res) => {
      console.log(res);
      this.userData = res;
      this.profileForm.controls["displayName"].patchValue(
        this.userData.displayName ? this.userData.displayName : "-"
      );
      this.profileForm.controls["firstName"].patchValue(
        this.userData.firstName ? this.userData.firstName : ""
      );
      this.profileForm.controls["lastName"].patchValue(
        this.userData.lastName ? this.userData.lastName : ""
      );
      this.profileForm.controls["email"].patchValue(
        this.userData.email ? this.userData.email : ""
      );
      this.profileForm.controls["mobile"].patchValue(this.userData.mobile);
      this.profileForm.controls["profileImageURL"].patchValue(
        this.userData.profileImageURL
      );
      this.profileForm.controls["countryCode"].patchValue(
        this.userData.countryCode
      );
      this.profileForm.controls["phoneNumber"].patchValue({
        number: this.userData.mobile ? this.userData.mobile : "",
        countryCode: this.userData.countryCode
          ? this.userData.countryCode
          : this.getCountryIso(),
      });
      this.displayingImage =
        this.userData.profileImageURL === this.businessUserIcon
          ? ""
          : this.userData.profileImageURL;
      this.profileForm.controls["companyName"].patchValue(
        this.userData.companyName
      );
      if (this.userData.mobile === this.userData.username) {
        this.profileForm.controls["phoneNumber"].disable();
      }
      this.isFormData = true;
      console.log(this.profileForm.value);
      this.uploadFiles.profileImage = {
        formData: new FormData(),
        patchKey: "profileImageURL",
      };
    });
    this.setDimensions();
  }

  async assignFormData(data) {
    this.uploadFiles.profileImage = this.businessUsersApiService.valueChangesProfileImage(
      data,
      this.uploadFiles.profileImage
    );
    this.imagesService
      .updateProfileImage(this.uploadFiles, this.businessUserIcon)
      .then((values) => {
        console.log(values);
        this.displayingImage =
          values.profileImageURL === this.businessUserIcon
            ? ""
            : values.profileImageURL;
      })
      .catch((err) => {});
    this.profileForm.controls.profileImageURL.markAsDirty();
  }
  deleteImage() {
    this.displayingImage = "";
    this.profileForm.controls.profileImageURL.markAsDirty();
  }
  setDisplayName() {
    // if (!this.profileForm.controls.displayName.touched) {
    let displayName = this.profileForm.controls.lastName.value || "";
    displayName = this.profileForm.controls.firstName.value
      ? this.profileForm.controls.firstName.value + " " + displayName
      : displayName;
    this.profileForm.controls.displayName.patchValue(displayName);
    // }
  }

  validUserForm() {
    return (
      this.profileForm.dirty &&
      (this.profileForm.controls["lastName"].value.length > 0 ||
        this.profileForm.controls["firstName"].value.length > 0 ||
        this.profileForm.controls["displayName"].value.length > 0 ||
        this.profileForm.controls.profileImageURL.dirty) &&
      this.validPhone()
    );
  }

  validPhone() {
    // return this.profileForm.controls["phoneNumber"].value
    //   ? !this.profileForm.controls["phoneNumber"].invalid
    //   : true;

    const phoneFormat = this.profileForm.controls["phoneNumber"].value;
    let phoneNumberInvalid = false;
    if (
      phoneFormat &&
      (phoneFormat.nationalNumber?.length || phoneFormat.number?.length)
    ) {
      const formattedNumber = phoneFormat.nationalNumber
        ? phoneFormat.e164Number.slice(phoneFormat.dialCode.length)
        : phoneFormat.number;
      if (!this.phoneRegex.test(formattedNumber)) {
        phoneNumberInvalid = true;
      } else {
        phoneNumberInvalid = formattedNumber?.length
          ? this.changeCountry(phoneFormat)
          : false;
      }
    } else {
      phoneNumberInvalid = false;
    }
    return !phoneNumberInvalid;
  }

  changeCountry(phoneFormat) {
    const formattedNumber = phoneFormat.nationalNumber
      ? phoneFormat.e164Number.slice(phoneFormat.dialCode.length)
      : phoneFormat.number;
    if (
      phoneFormat &&
      phoneFormat.countryCode === "DE" &&
      phoneFormat.dialCode === "+49"
    ) {
      return formattedNumber.length < 6 || formattedNumber.length > 13;
    } else if (
      phoneFormat &&
      phoneFormat.countryCode === "IN" &&
      phoneFormat.dialCode === "+91"
    ) {
      return formattedNumber.length !== 10;
    } else {
      return formattedNumber.length < 6 || formattedNumber.length > 13;
    }
  }

  validEmail() {
    return (
      this.profileForm.controls["email"].value &&
      this.regexService
        .getEmailRegex()
        .test(this.profileForm.controls["email"].value)
    );
  }
  getCountryIso() {
    if (this.profileForm.controls["countryCode"].value?.length > 0) {
      return this.profileForm.controls["countryCode"].value;
    } else {
      let countryObj = this.slotService.getCountryObjectByBusinessUnit(true);
      return countryObj ? countryObj.isoCode : "IN";
    }
  }
  formPhoneNumber() {
    const phoneNumber = this.profileForm.controls["phoneNumber"].value;
    if (phoneNumber && phoneNumber.e164Number) {
      this.phoneNumber = Number(
        phoneNumber.e164Number.slice(
          phoneNumber.dialCode.length,
          phoneNumber.e164Number.length
        )
      );
    } else {
      this.phoneNumber =
        phoneNumber && phoneNumber.number
          ? Number(phoneNumber.number.replace(/[^0-9]/g, ""))
          : "";
    }
  }
  updateUser() {
    this.formPhoneNumber();
    if (this.profileForm.controls.phoneNumber.value) {
      this.profileForm.controls.mobile.patchValue(this.phoneNumber);
      this.profileForm.controls.countryCode.patchValue(
        this.profileForm.controls.phoneNumber.value.countryCode
      );
      this.profileForm.controls.dialCode.patchValue(
        this.profileForm.controls.phoneNumber.value.dialCode
      );
    } else {
      this.profileForm.controls.mobile.patchValue("");
      this.profileForm.controls.countryCode.patchValue("");
    }
    this.signinService.updateCurrentUserData(this.profileForm.value).subscribe(
      (res) => {
        this.userData = res;
        const user = JSON.parse(localStorage.getItem("user"));
        user.displayName = this.userData.user.displayName;
        user.mobile = this.userData.user.mobile;
        user.countryCode = this.userData.user.countryCode;
        user.profileImageURL = this.userData.user.profileImageURL;
        user.dialCode = this.userData.user.dialCode;
        localStorage.setItem("user", JSON.stringify(user));
        this.localStorageService.islocalStorageUpdated.next(true);
        this.slotService.profileUpdated.next(true);
        this.scrollTop();
        if (!this.isMobileDevice() || this.dialogRef) {
          this.dialogRef.close(this.userData.user);
        } else {
          this.localStorageService.isMobileUpdate = true;
          this.dialogService.openMatDialog(SideNavComponent, {
            width: "100%",
            height: "100%",
            maxWidth: "100%",
          });
        }
      },
      (err) => {
        this.toastrService.error(err.error.message, null, {
          timeOut: 2000,
        });
      }
    );
  }
  scrollTop() {
    window.scrollTo({ top: 0 });
  }
  onUpdate() {
    if (this.profileForm.dirty) {
      this.profileForm.patchValue({
        profileImageURL:
          this.displayingImage === ""
            ? this.businessUserIcon
            : this.displayingImage,
      });
      this.toastrService.success("Profile updated successfully", null, {
        timeOut: 2000,
      });
      this.updateUser();
    } else {
      console.log("dev name1", this.profileForm.controls["displayName"].value);
      this.updateUser();
    }
  }
  closeCreation() {
    this.scrollTop();
    this.dialogRef.close();
  }
  setDimensions() {
    const dimensions = setActualDimensions();
    this.windowHeight = dimensions.windowHeight;
    this.windowWidth = dimensions.windowWidth;
  }
  isMobileDevice() {
    return this.windowWidth <= 6;
  }
  isTabDevice() {
    return this.windowWidth > 6 && this.windowWidth <= 12;
  }
  isUserConsumer() {
    let index = -1;
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user && this.user.companies && this.user.companies.length) {
      index = this.user.companies.findIndex((company) => company.consumer);
    }
    if (index < 0 && this.user.type && this.user.type === "B2C") {
      index = 0;
    }
    return index >= 0;
  }
}
